import React, { useEffect } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form, Input } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
const RemoveInventoryModal: React.FC<RemoveInventoryModalProps> = ({
  show,
  handleClose,
  intPkInventoryStockID,
  quantity,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<RemoveInventoryApiProp>("inventory/removeInventory", true);

  const onFinish = (values: any) => {
    const { quantityToRemove } = values;
    const dataToSend: RemoveInventoryApiProp = {
      quantity: Number(quantityToRemove),
      intPkInventoryStockID,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Deduct Items"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="removeInventoryFrom"
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">
                    Items to Deduct
                  </span>
                }
                name="quantityToRemove"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Quantity",
                  },
                  {
                    validator: (_, value) =>
                      value > 0
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Quantity must be greater than 0")
                          ),
                  },
                  {
                    validator: (_, value) =>
                      value > quantity
                        ? Promise.reject(
                            new Error(
                              `Available Quantity to remove :${quantity}`
                            )
                          )
                        : Promise.resolve(),
                  },
                ]}
              >
                <Input
                  type="number"
                  className="user-input-general-height"
                  placeholder="12"
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.DANGER}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Remove"
                  disabled={apiLoading}
                  borderColor="#DF3131"
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default RemoveInventoryModal;
